/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalType = "completable" | "continuous" | "%future added value";
export type GoalDetailsTitleDescription_goal = {
    readonly type: GoalType;
    readonly archived: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsTitle_goal" | "GoalDetailsDescription_goal">;
    readonly " $refType": "GoalDetailsTitleDescription_goal";
};
export type GoalDetailsTitleDescription_goal$data = GoalDetailsTitleDescription_goal;
export type GoalDetailsTitleDescription_goal$key = {
    readonly " $data"?: GoalDetailsTitleDescription_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsTitleDescription_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsTitleDescription_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsTitle_goal"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "GoalDetailsDescription_goal"
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = 'a958dc2873c81295b0bd80fd0b7b83e9';
export default node;
